export default "__VITE_ASSET__j4kypNe5__"